import Request from './request'
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'


async function fetch(data) {
    return Request('get', "api/stock-ins", data);
}

async function fetchOne(id, data) {
    return Request('get', "api/stock-ins/" + id, data);
}

async function edit(id, data) {// 编辑入库单
    return Request('patch', "api/stock-ins/edit/" + id, data);
}

async function add(data) {// 新增入库单
    return Request('post', "api/stock-ins/add", data);
}

async function stockIN(type, data) {
    let url = 'api/stock-ins/in'
    if (type == 'inCompleteAndLoss') {
        url = 'api/stock-ins/in?requisition_in_loss=1'
    }
    return Request('post', url, data)
}

async function shelveOnBatch(data) {//批量上架
    return Request('post', "api/stock-ins/batch-shelve-on", data);
}

async function approve(id) {
    return Request('get', "api/stock-ins/approve/" + id);
}

async function cancel(id) {
    return Request('get', "api/stock-ins/cancel/" + id);
}

async function stockOrderInPrint(id) {
    return Request('get', "api/stock-ins/stock-order-print/" + id)
}

async function stockOrdersInPrint(data) {
    return Request('get', "api/stock-ins/stock-orders-print/", data)
}

async function exportDetail(id, data) {
    // 入库单明细导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', "api/stock-ins/detail-export/" + id, data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function batchDetailExport(data) {
    // 入库单明细批量导出
    store.dispatch('fullscreenLoading')
    const response = await Request('get', "api/stock-ins/batch-detail-export", data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function inTemplateExport(data) {
    // 入库单导入模板下载
    store.dispatch('fullscreenLoading')
    const response = await Request('get', "api/stock-ins/in-template-export", data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function initTemplateExport(data) {
    // 期初导入模板下载
    store.dispatch('fullscreenLoading')
    const response = await Request('get', "api/stock-ins/init-template-export", data)
    if (response.data && response.data.status.isOK()) {
        snackbar.info(i18n.t('Export.recordedHint'))
    }
    store.dispatch('fullscreenLoadingStop')
    return response
}

async function imports(file, stockId) {// 入库单导入
    var data = new FormData();
    data.append("excel", file);
    data.append("stock_id", stockId);
    return Request('post', "api/stock-ins/get-in-template", data); 
}

async function initImports(file, stockId) {// 期初入库
    var data = new FormData();
    data.append("excel", file);
    data.append("stock_id", stockId);
    return Request('post', "api/stock-ins/get-init-template", data);
}

async function update(data) {
    return Request('post', 'api/stock-ins/update', data)
}

async function batchIn(data) {
    //批量审批
    return Request('post', 'api/stock-ins/batch-in', data, false, false, true)
}
  
  
export default {
    fetch,
    fetchOne,
    edit,
    add,
    stockIN,
    shelveOnBatch,
    approve,
    cancel,
    stockOrderInPrint,
    stockOrdersInPrint,
    exportDetail,
    batchDetailExport,
    inTemplateExport,
    initTemplateExport,
    imports,
    initImports,
    update,
    batchIn,
};